const applyTemplate = (template: string, replacements: Record<string, string>, encode = true): string => {
  return template.replace(/{(\w+)}/g, function (e, n) {
    if (!replacements[n]) {
      return ''
    }
    return encode ? encodeURIComponent(replacements[n]) : replacements[n]
  })
}

export const navigateTo = (url: string): void => {
  const targetUrl = applyTemplate(url, {
    redirectTo: window.location.href
  })

  window.open(targetUrl, '_blank')
}

export const navigateToProvider = (url: string): void => {
  window.location.href = applyTemplate(url, {
    redirectTo: window.location.href
  })
}
